"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addPropsToReactElement = void 0;
const react_1 = require("react");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const addPropsToReactElement = (element, props) => {
    if (!react_1.isValidElement(element)) {
        throw new Error('Invalid react element found in the tree');
    }
    return react_1.cloneElement(element, props);
};
exports.addPropsToReactElement = addPropsToReactElement;
//# sourceMappingURL=add-props-to-element.js.map